<div class="search">
    <form class="search__form" action="">
        <input [(ngModel)]="palabra" class="search__input" name="search" placeholder="Busqueda..." aria-label="Site search" type="text" autocomplete="off">
        <button (click)="busqueda()" (keyup.enter)="busqueda()" class="search__button" type="submit">
            <app-icon name="search-20" size="20"></app-icon>
        </button>
        <div class="search__border"></div>
    </form>
</div>
